import React from "react";

interface PageLoaderProps {
  message?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ message }) => {
  const loadingMessage = message || "Loading session details...";

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-background text-text-primary"
      role="status"
      aria-live="polite"
      aria-label={loadingMessage}
    >
      <div className="animate-pulse font-pixel text-primary mb-4">
        {loadingMessage}
      </div>
      <div
        className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"
        aria-hidden="true"
      />
    </div>
  );
};

export default PageLoader;
